var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-overlay',{attrs:{"z-index":_vm.zIndex,"opacity":_vm.opacity,"value":_vm.overlay,"color":"#239FAB"}},[_c('v-progress-circular',{attrs:{"size":200,"width":7,"color":"white","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }